var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 19,
    height: 19,
    rx: 1.5,
    fill: "white",
    stroke: "#EDEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22765 14.3539C8.1582 14.3539 8.09455 14.3423 8.03668 14.3192C7.9788 14.296 7.92093 14.2555 7.86306 14.1976L4.7207 11.0553C4.61654 10.9511 4.56445 10.8238 4.56445 10.6733C4.56445 10.5229 4.61654 10.3956 4.7207 10.2914C4.82487 10.1872 4.9464 10.1351 5.08529 10.1351C5.22418 10.1351 5.3457 10.1872 5.44987 10.2914L8.22765 13.0692L14.5297 6.76709C14.6339 6.66292 14.7583 6.61084 14.903 6.61084C15.0477 6.61084 15.1721 6.66292 15.2763 6.76709C15.3804 6.87126 15.4325 6.99568 15.4325 7.14035C15.4325 7.28503 15.3804 7.40945 15.2763 7.51362L8.59223 14.1976C8.53436 14.2555 8.47649 14.296 8.41862 14.3192C8.36075 14.3423 8.29709 14.3539 8.22765 14.3539Z",
    fill: "#A1ACAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.68292cbf.svg";
export { ForwardRef as ReactComponent };